// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const Table = styled<any, Theme>('table')`
  border-spacing: 0;
  padding-top: 2.25rem;
  width: 100%;

  &:first-of-type {
    padding-top: 0.5rem;
  }
`;

export default Table;
